export default __webpack_public_path__ + "static/media/modes.bde7deb4.md";